import {useEffect } from 'react';

const useUnsavedChangesWarning = (count)=>{
  useEffect(()=>{
    if(count){
      window.addEventListener("beforeunload", alertUser);
      return () => {
        window.removeEventListener("beforeunload", alertUser);
      };
    }
  },[count]);
  return useUnsavedChangesWarning;
};

const alertUser = (e) => {
  e.preventDefault();
  e.returnValue = "";
};
  
export default useUnsavedChangesWarning ;
